import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { contentData } from '../data/contentData';

const BenefitsGrid = () => {
  const { language } = useLanguage();
  const content = contentData[language].benefits;
  const [expandedCards, setExpandedCards] = useState({});

  const toggleCard = (index) => {
    setExpandedCards(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const iconColors = [
    '#6C3AED', '#0EA5E9', '#10B981', '#F59E0B', '#EF4444', '#EC4899'
  ];

  return (
    <section className="benefits-section" style={{ 
      padding: '80px 0', 
      background: '#F8FAFC',
      fontFamily: '"Inter", sans-serif'
    }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center" style={{ 
              fontSize: '2.5rem', 
              fontWeight: '700',
              color: '#0F172A',
              marginBottom: '5rem',
              lineHeight: '1.4',
              fontFamily: '"Playfair Display", serif'
            }}
            data-aos="fade-up"
            >
              {content.title}
            </h2>
          </div>
          
          <div className="row">
            {content.cards.map((card, index) => {
              const isExpanded = expandedCards[index];
              const iconColor = iconColors[index % iconColors.length];
              
              return (
                <div 
                  key={index} 
                  className="col-lg-6 col-md-6 mb-4"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  data-aos-duration="600"
                >
                  <div 
                    className="card border-0 h-100"
                    style={{
                      background: '#FFFFFF',
                      borderRadius: '16px',
                      border: '1px solid #E2E8F0',
                      overflow: 'hidden',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 12px 32px rgba(108,58,237,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.04)';
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0 me-3">
                          <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            background: `${iconColor}14`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <i 
                              className={`${card.icon}`}
                              style={{ color: iconColor, fontSize: '1.25rem' }}
                            ></i>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h5 
                            className="mb-2"
                            style={{ 
                              color: '#0F172A',
                              fontSize: '1.1rem',
                              fontWeight: '600',
                              fontFamily: '"Inter", sans-serif'
                            }}
                          >
                            {card.title}
                          </h5>
                          <div style={{ 
                            color: '#64748B',
                            fontSize: '0.9rem',
                            lineHeight: '1.6',
                            fontFamily: '"Inter", sans-serif',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: isExpanded ? 'unset' : '3',
                            WebkitBoxOrient: 'vertical'
                          }}
                          dangerouslySetInnerHTML={{ __html: card.description }}
                          >
                          </div>
                          <button
                            onClick={() => toggleCard(index)}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#6C3AED',
                              fontSize: '0.85rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              padding: '4px 0 0',
                              fontFamily: '"Inter", sans-serif'
                            }}
                          >
                            {isExpanded ? (language === 'ar' ? 'أقل' : 'Read less') : (language === 'ar' ? 'المزيد' : 'Read more')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsGrid;